module.exports = __webpack_public_path__ + "6f433d2da94107ce43aa04f91f7c15bb.pdf";